export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.727 52.394\"><path d=\"M0 0h19.727v52.394h-5.982Z\" fill=\"currentColor\"/></svg>";